import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {

  orderdetail:'/teams/order/',
  delorder:'/teams/order/',
  fabuorder:'/teams/order/fabuorder/',
  baojiadan:'/teams/order/createbaojiafile/'
}



export function orderdetail (id) {
  return axios({
    url: api.orderdetail+id+'/',
    method: 'get',

  })
}
export function delorder (id) {
  return axios({
    url: api.delorder+id+'/',
    method: 'delete',

  })
}
export function fabuorder (data) {
  return axios({
    url: api.fabuorder,
    method: 'post',
    data

  })
}

export function baojiadan (params) {
  return axios({
    url: api.baojiadan,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/views/salerviews/orderdetail/api.js